module.exports = __webpack_public_path__ + "media/images/undraw/reserve/export_files-7f8e5791c572fe78dae4e6e8f3522d3a.png";